import api from './api';
import buildUrl from '../../utils/helpers/buildUrl';
import {prepareLocalViewings} from '../../utils/helpers/property';
import * as consts from '../../utils/constants/url';

const viewingApi = api.injectEndpoints({
  endpoints: build => ({
    getUpcomingViewingsByProperty: build.query({
      query: ({id, options = {}} = {}) =>
        buildUrl(`${consts.API_PROPERTY_VIEWINGS}/${id}`, options),
      transformResponse: ({data}) => ({
        ...data,
        prepared: prepareLocalViewings(data),
      }),
    }),
  }),
});

export const {useGetUpcomingViewingsByPropertyQuery} = viewingApi;

export default viewingApi;
